import {API} from "aws-amplify";

export const BeneficiaryAPI = {
    fetchBeneficiaryById: (id) => API.get("beneficiaries", `/get/id/${id}`, ""),
    fetchBeneficiaries: () => API.get('beneficiaries', `/beneficiaries/get`, {})
}